export const METAMASK = 'MetaMask' // metamask wallet constant
export const TALLYHO = 'TallyHo' // tally wallet constant
export const BLOCKWALLET = 'BlockWallet' // BlockWallet wallet constant
export const WALLETCONNECT = 'WalletConnect' // walletConnect wallet constant
export const COINBASE = 'Coinbase' // coinbase wallet constant
export const BRAVE = 'Brave' // brave wallet constant
export const OKXWALLET = 'OKXWallet' // okx wallet constant
export const IM_TOKEN_APP = 'imTokenApp' // imToken app name
export const BIT_KEEP_APP = 'bitKeepApp' // bitKeep app name
export const COINBASE_APP = 'coinbaseApp' // coinbase app name
export const METAMASK_APP = 'metamaskApp' // metamask app name
export const TOKEN_POCKET_APP = 'tokenPocketApp' // token pocket app name
export const LOCALLOGINDATA = 'localLoginData' // mainly used in localStorage for store the information if any wallets have been logged in
export const BRAVE_APP = 'braveApp' // brave wallet constant
